import * as ACTION from '@Bootstraps/bootstrapActions';
import * as COMPONENT from '@Components';
import * as IMG from '@Utils/Images';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import '@Styles/auth.css';

export default function Page() {
  const [formData, setFormData] = useState({
    avatar: '',
    name: {
      firstName: '',
      lastName: '',
    },
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [showImage, setShowImage] = useState(IMG.EMPTY_AVATAR);
  const [isSame, setIsSame] = useState(false);
  const [seePassword, setSeePassword] = useState(false);
  const [error, setError] = useState(false);

  const { registrationResponse, registrationError } = useSelector(state => state);
  const dispatch = useDispatch();

  function formChange(title, value) {
    setFormData((prev) => ({ ...prev, [title]: value }));
  };

  useEffect(() => {
    if (registrationResponse && registrationResponse.data) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Success Registration',
        text: registrationResponse?.data?.message || 'New user added',
        confirmButtonColor: '#3dcd55',
        icon: 'success',
      }).then(() => window.location.assign("/login"));
    } else if (registrationError) {
      setLoading(false);
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Failed Registration',
        text: registrationError?.message || 'Failed registration',
        confirmButtonColor: '#3dcd55',
        icon: 'error',
      });
    }
  }, [dispatch, registrationResponse, registrationError]);

  useEffect(() => {
    let password = document.getElementById('password');
    let confirmPassword = document.getElementById('confirmPassword');

    if (seePassword) {
      password.type = 'text';
      confirmPassword.type = 'text';
    } else {
      password.type = 'password';
      confirmPassword.type = 'password';
    }
  }, [seePassword]);

  return (
    <section className="auth">
      {error ? (
        <div
          className="alert fixed-top alert-danger alert-dismissible fade show ps-md-5 m-0"
          role="alert"
        >
          <p className="fw-bold text-danger m-0">
            Username atau Password Salah!
          </p>
          <button
            type="button"
            className="btn-close shadow-none me-md-5"
            data-bs-dismiss="alert"
            onClick={() => setError(false)}
            aria-label="Close"
          ></button>
        </div>
      ) : (
        ''
      )}
      <div className="row justify-content-between align-items-center min-vh-100 m-0">
        <div className="col-lg-5 auth-left order-lg-1 order-2 py-lg-5">
          <div className="header mb-5">
            <h1>
              Welcome to{' '}
              <Link to="/" className="text-dark">
                B<span className="text-primary2">HEV</span>IN
              </Link>
            </h1>
            <p className="normal mt-3">
              Please registration to continue access
            </p>
          </div>

          <form
            className="auth-form"
            id="authForm"
            onSubmit={(e) => {
              e.preventDefault();
              if (isSame) {
                setLoading(true);
                const form = new FormData();

                for (let data in formData) {
                  if (formData[data] !== '') {
                    if (data === 'name') {
                      for (let name in formData[data]) {
                        form.append(`${data}.${name}`, formData[data][name]);
                      }
                    } else {
                      form.append(data, formData[data]);
                    }
                  }
                }

                dispatch(ACTION.registration(form));
              } else {
                Swal.fire({
                  background: '#252336',
                  color: '#3dcd55',
                  title: 'Failed Registration',
                  text: 'Confirm Password must same with Password',
                  confirmButtonColor: '#3dcd55',
                  icon: 'error',
                });
              }
            }}
          >
            <div>
              <label htmlFor="avatar" className="cursor-pointer">
                <div
                  className="avatar rounded-circle"
                  style={{ backgroundImage: `url(${showImage})` }}
                />
              </label>
              <input
                type="file"
                id="avatar"
                name="avatar"
                accept="image/*"
                hidden
                onChange={(e) => {
                  const image = e.target.files[0];
                  setShowImage(URL.createObjectURL(image));
                  formChange('avatar', image);
                }}
              />
            </div>
            <div className="row m-0 my-4">
              <div className="col-lg-6 ps-0 pe-0 pe-lg-3">
                <label
                  htmlFor="firstName"
                  className="form-label fw-medium normal mb-2"
                >
                  First Name
                </label>
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  className="form-control shadow-none px-3 py-2 fw-medium"
                  placeholder="eg. firstname"
                  value={formData.name.firstName}
                  required
                  onChange={(el) => {
                    el.preventDefault();
                    setFormData((prev) => ({
                      ...prev,
                      name: { ...prev.name, firstName: el.target.value },
                    }));
                  }}
                />
              </div>
              <div className="col-lg-6 ps-0 ps-lg-2 pe-0 mt-4 mt-lg-0">
                <label
                  htmlFor="lastname"
                  className="form-label fw-medium normal mb-2"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  name="lastname"
                  id="lastname"
                  className="form-control shadow-none px-3 py-2 fw-medium"
                  placeholder="eg. lastname"
                  value={formData.name.lastName}
                  required
                  onChange={(el) => {
                    el.preventDefault();
                    setFormData((prev) => ({
                      ...prev,
                      name: { ...prev.name, lastName: el.target.value },
                    }));
                  }}
                />
              </div>
            </div>

            <div className="row m-0 my-4">
              <div className="col-lg-6 ps-0 pe-0 pe-lg-3">
                <label
                  htmlFor="username"
                  className="form-label fw-medium normal mb-2"
                >
                  Username
                </label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  className="form-control shadow-none px-3 py-2 fw-medium"
                  placeholder="eg. user"
                  value={formData.username}
                  required
                  onChange={(el) => {
                    el.preventDefault();
                    formChange('username', el.target.value);
                  }}
                />
              </div>
              <div className="col-lg-6 ps-0 ps-lg-2 pe-0 mt-4 mt-lg-0">
                <label
                  htmlFor="email"
                  className="form-label fw-medium normal mb-2"
                >
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="form-control shadow-none px-3 py-2 fw-medium"
                  placeholder="eg. email@example.com"
                  value={formData.email}
                  required
                  onChange={(el) => {
                    el.preventDefault();
                    formChange('email', el.target.value);
                  }}
                />
              </div>
            </div>

            <div className="my-4">
              <label
                htmlFor="password"
                className="form-label fw-medium normal mb-2"
              >
                Password
              </label>
              <COMPONENT.Input
                type="password"
                idname="password"
                placeholder={'eg. *****'}
                value={formData.password}
                onChange={(val) => {
                  formChange('password', val);
                  setIsSame(formData.confirmPassword === val);
                }}
              />
            </div>

            <div className="my-4">
              <label
                htmlFor="confirmPassword"
                className="form-label fw-medium normal mb-2"
              >
                Confirm Password
              </label>
              <COMPONENT.Input
                type="password"
                className={!isSame ? 'border-danger' : ''}
                idname="confirmPassword"
                placeholder={'eg. *****'}
                onChange={(val) => {
                  formChange('confirmPassword', val);
                  setIsSame(formData.password === val);
                }}
              />
            </div>

            <div className="d-flex align-items-center mt-4 mb-5">
              <div className="position-relative see-password cursor-pointer">
                <input
                  type="checkbox"
                  id="seePassword"
                  name="seePassword"
                  className="form-check-input"
                  onClick={() => setSeePassword(!seePassword)}
                />
                <h5
                  className={`m-0 mt-1 ${seePassword ? 'd-none' : 'd-block'}`}
                  id="hide"
                >
                  <i className="fa-solid fa-eye-slash"></i>
                </h5>
                <h5
                  className={`m-0 mt-1 ${seePassword ? 'd-block' : 'd-none'}`}
                  id="show"
                >
                  <i className="fa-solid fa-eye"></i>
                </h5>
              </div>
              <label
                htmlFor="seePassword"
                className="form-label cursor-pointer fw-semibold normal ms-3 mt-2 user-select-none"
              >
                See Password
              </label>
            </div>

            <button
              type="submit"
              className="button-auth fw-semibold py-25 rounded-3"
              disabled={loading}
            >
              Registration
            </button>
            <div className="text-center mt-4">
              <Link to="/login" className="fw-medium normal text-primary2">
                Already have an account?
              </Link>
            </div>
          </form>
        </div>
        <div className="col-lg-7 p-0 order-lg-2 order-1">
          <div
            id="carouselExampleControls"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_1})`,
                  }}
                />
              </div>
              <div className="carousel-item" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_2})`,
                  }}
                />
              </div>
              <div className="carousel-item" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_3})`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
